const DeliveryInformation = () => (
  <div className="product-actions__delivery-information bs-bb">
    <p className="tc-secondary m-0 fs-14">
      <span className="bold tc-main block">
        Free delivery on orders over £50
      </span>
      <span className="fs-14 block">£5.95 Delivery on orders under £50</span>
    </p>
  </div>
);

export default DeliveryInformation;
